export const sessIdCookieName = 'sess1id';
export const userTokenKey = 'user1tok';
export const apolloExtraCacheKeyCookName = 'cache1version';
